import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=A%20stylized%20artistic%20illustration%20with%20Korean%20manhwa%20comic%20book%20elements%2C%20soft%20warm%20gradients%20of%20coral%20pink%20and%20deep%20burgundy%2C%20abstract%20ink%20wash%20textures%2C%20subtle%20line%20art%20patterns%20reminiscent%20of%20comic%20panels%2C%20elegant%20and%20atmospheric%20composition%2C%20no%20text%2C%20clean%20artistic%20background&width=1600&height=900&seq=hero-bg-kr-comic&orientation=landscape"
        alt="韩国漫画网"
        className="absolute inset-0 w-full h-full object-cover object-center"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/50 via-foreground-950/30 to-foreground-950/60"></div>

      <div className="relative z-10 w-full px-4 md:px-6 text-center">
        <div className="max-w-3xl mx-auto">
          <div className="inline-flex items-center gap-2 bg-background-50/15 backdrop-blur-sm border border-background-50/20 rounded-full px-4 py-1.5 mb-6">
            <i className="ri-sparkling-line text-accent-300 text-sm"></i>
            <span className="text-background-50/80 text-xs md:text-sm">每日更新 · 海量韩漫 · 完全免费</span>
          </div>

          <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-black text-background-50 mb-4 leading-tight">
            韩国漫画网
          </h1>
          <p className="text-lg md:text-xl text-background-50/70 mb-3 font-heading">
            韩漫大全 · 下拉式漫画全集在线阅读
          </p>
          <p className="text-sm md:text-base text-background-50/50 mb-8 max-w-xl mx-auto leading-relaxed">
            资源丰富，更新迅速，分类清晰，为您带来最便捷的韩国漫画在线阅读体验
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link
              to="/category/romance"
              className="inline-flex items-center gap-2 bg-primary-500 hover:bg-primary-600 text-background-50 px-8 py-3 rounded-full font-medium text-sm transition-all whitespace-nowrap cursor-pointer"
            >
              <i className="ri-book-read-line"></i>
              开始阅读
            </Link>
            <Link
              to="/about"
              className="inline-flex items-center gap-2 bg-background-50/15 hover:bg-background-50/25 backdrop-blur-sm border border-background-50/25 text-background-50 px-8 py-3 rounded-full font-medium text-sm transition-all whitespace-nowrap cursor-pointer"
            >
              <i className="ri-information-line"></i>
              了解更多
            </Link>
          </div>

          <div className="flex items-center justify-center gap-8 mt-12">
            <div className="text-center">
              <div className="text-2xl md:text-3xl font-bold text-background-50">10,000+</div>
              <div className="text-xs text-background-50/50 mt-1">漫画资源</div>
            </div>
            <div className="w-px h-10 bg-background-50/20"></div>
            <div className="text-center">
              <div className="text-2xl md:text-3xl font-bold text-background-50">50M+</div>
              <div className="text-xs text-background-50/50 mt-1">月访问量</div>
            </div>
            <div className="w-px h-10 bg-background-50/20"></div>
            <div className="text-center">
              <div className="text-2xl md:text-3xl font-bold text-background-50">8</div>
              <div className="text-xs text-background-50/50 mt-1">大分类</div>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 animate-bounce">
        <i className="ri-arrow-down-line text-background-50/40 text-2xl"></i>
      </div>
    </section>
  );
}